<template>
    <div>
        <h1>This is the AdmissionView Page </h1>
    </div>
</template>

<script>
export default {
    name : "AdmissionView"
};
</script>
